// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.maxlengthInput .el-input__inner,\n.maxlengthInput .el-textarea__inner {\n  padding-right: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
